import { render, staticRenderFns } from "./LectureCenter.vue?vue&type=template&id=69d841af&scoped=true&"
import script from "./LectureCenter.vue?vue&type=script&lang=js&"
export * from "./LectureCenter.vue?vue&type=script&lang=js&"
import style0 from "./LectureCenter.vue?vue&type=style&index=0&id=69d841af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d841af",
  null
  
)

export default component.exports